import React from "react";

import { useTranslation, Trans } from "react-i18next";

import img from '../../img/Home/img.png'
import Button from '../Button'

function WeHaveTransparent () {

    const { t } = useTranslation();
      
    return(
        <div className="relative overflow-hidden">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[100px] xl:pt-[160px]">  
                <div className="flex flex-col-reverse xl:flex-row justify-between">
                    <img src={img} alt="" className="mx-auto xl:mx-0 mt-[60px] xl:mt-0"/>
                    <div>
                        <p className="merriweather spantext italic font-[700] xl:text-[40px] text-[32px]"><Trans>{t('home.40')}</Trans></p>
                        <p className="xl:max-w-[487px] inter fdfd text-[14px] xl:text-[16px] font-[300] mt-[30px]"><Trans>{t('home.41')}</Trans></p>
                        <div className="flex gap-[25px] items-center mt-[15px] xl:mt-[20px]">
                            <svg className="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M13.5 0C6.05618  0 0 6.05618 0 13.5C0 20.9438 6.05618 27 13.5 27C20.9438 27 27 20.9438 27 13.5C27 6.05618 20.9438 0 13.5 0ZM11.0337 20.2747L5.8024 14.4612L7.34647 13.0716L10.9811 17.11L19.601 6.84476L21.1937 8.17789L11.0337 20.2747Z" fill="#0BD752"/>
                            </svg>
                            <p className="text-[#313131] text-[14px] xl:text-[17px]">{t('home.42')}</p>
                        </div>
                        <div className="flex gap-[25px] items-center mt-[15px] xl:mt-[20px]">
                            <svg className="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M13.5 0C6.05618  0 0 6.05618 0 13.5C0 20.9438 6.05618 27 13.5 27C20.9438 27 27 20.9438 27 13.5C27 6.05618 20.9438 0 13.5 0ZM11.0337 20.2747L5.8024 14.4612L7.34647 13.0716L10.9811 17.11L19.601 6.84476L21.1937 8.17789L11.0337 20.2747Z" fill="#0BD752"/>
                            </svg>
                            <p className="text-[#313131] text-[14px] xl:text-[17px]">{t('home.43')}</p>
                        </div>
                        <div className="flex gap-[25px] items-center mt-[15px] xl:mt-[20px]">
                            <svg className="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M13.5 0C6.05618  0 0 6.05618 0 13.5C0 20.9438 6.05618 27 13.5 27C20.9438 27 27 20.9438 27 13.5C27 6.05618 20.9438 0 13.5 0ZM11.0337 20.2747L5.8024 14.4612L7.34647 13.0716L10.9811 17.11L19.601 6.84476L21.1937 8.17789L11.0337 20.2747Z" fill="#0BD752"/>
                            </svg>
                            <p className="text-[#313131] text-[14px] xl:text-[17px]">{t('home.44')}</p>
                        </div>
                        <p className="xl:max-w-[487px] inter fdfd text-[14px] xl:text-[16px] font-[300] mt-[20px]"><Trans>{t('home.45')}</Trans></p>
                        <Button className={"mt-[40px] xl:mt-[26px]"}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WeHaveTransparent;